<template>
    <div :style="{height:'100%'}"   class="d-flex justify-center mobile-column"  >
                  
                    <v-btn
                        elevation="0"
                        icon
                        class="bttn-go-back"
                        style=""
                        v-if="step > 1"
                        @click="step = step-1"
                    >
                        <v-icon >
                           mdi-arrow-left                
                        </v-icon>
                    </v-btn>
        <router-link to="/" class="a-10">
            <v-img class="img-logo-nl"  alt="logo" src="@/assets/img/logo-genl.svg"></v-img>
        </router-link>
        <div class="fondo-register-mobile"></div>
        <v-row class="d-flex  mx-auto" style="height:100%;max-width:1600px;width:100%" >
            <v-col cols="12" md="6" lg="6" justify="center" class="mx-auto  no-justify-center-mobile d-flex flex-column " :style=" step == 1 ? {'margin-top':'7% !important', 'margin-bottom':'6% !important'} : { } "  >
                <v-card class="pa-6 mx-3" width="" style="border-radius:10px">

                    <v-card-subtitle class="text-center primary--text font-weight-black text-h5" style="color:#">REGISTRO</v-card-subtitle>
                    <!-- <v-img class="logo_tam" alt="Tamaulipas Logo" src="@/assets/img/logo_nl.png"></v-img> -->
                    <v-divider class="mt-2"></v-divider>
                    <!-- <v-card-subtitle class="primary--text text-h6 text-center mb-2">{{currentFormTitle}}</v-card-subtitle> -->

                    <!------------ VERIFY CURP  ----------------->
                    <v-card-text v-show="step === 0"  class="mx-auto my-16 width-register" >
                        <v-form   ref="curpValidationRef" v-model="curpFormValid" lazy-validation>
                                <label class="label-form">Ingresa tu CURP</label>
                                <v-text-field
                                        class="mb-0 pb-0"
                                        outlined required 
                                        v-model="registerRequest.curp"
                                        placeholder="CURP"
                                        @click:append="help('Ingresa su CURP correctamente.')"
                                        :rules="[formValidator.curp.required/*, formValidator.curp.ws_validate*/]"
                                        :loading="curpLoading"
                                        :error="curpError"
                                        :error-messages="curpMessage"
                                        maxlength="18"
                                        autofocus

                                />
                                 <v-row class="pl-2 my-6 justify-center">
                                    <vue-recaptcha
                                        :sitekey="getCaptchaSiteKey()"
                                        :loadRecaptchaScript="true"
                                        @verify="verifyReCaptcha"
                                        @expired="expiredRecaptcha"
                                    >
                                    </vue-recaptcha>
                                </v-row>
                                <v-btn v-if="!curpSuccess" block :color="pantoneBlack" x-large class="mb-4 white--text v-btn-height" @click="step= 1">No conozco mi CURP</v-btn>
                                <div v-if="!curpSuccess" class="w-100 d-flex">
                                    <label for="" class="mx-auto label-form">¿Ya tienes una cuenta? <a  href="/login"> Inicia sesión</a></label>
                                </div>
                                <template v-if="curpSuccess">
                                    <v-card-title class="label-form">Verifica que los datos correspondan</v-card-title>
                                    <label for="" class="label-form">"  Nombre(s)</label>
                                    <v-text-field
                                            class=""
                                            outlined required v-model="registerRequest.nombres"
                                            placeholder="Ingresa tu nombre"
                                            :rules="[formValidator.name.required]"
                                            readonly
                                    />
                                    <label for="" class="label-form">" Apellido paterno</label>
                                    <v-text-field
                                            class=""
                                            outlined required v-model="registerRequest.apellido_paterno"
                                            placeholder="Ingresa tu apellido paterno"
                                            :rules="[formValidator.lastname_pat.required]"
                                            readonly
                                    />
                                    <label for="" class="label-form">" Apellido materno</label>
                                    <v-text-field
                                            class=""
                                            outlined required v-model="registerRequest.apellido_materno"
                                            placeholder="Ingresa tu apellido materno"
                                            readonly
                                    />
                                    <v-btn block :color="pantoneBlack" x-large class="mb-4 white--text" @click="postCurFormValidation()">Continuar</v-btn>
                                </template>
                                <div v-if="curpSuccess" class="w-100 d-flex">
                                    <label for="" class="mx-auto label-form  text-center" >¿Ya tienes una cuenta? <a  href="/login"> Inicia sesión</a></label>
                                </div>
                            <!-- <v-btn block :color="pantoneBlack" large class="mb-4 white--text" @click="cancelRegister()">Cancelar</v-btn> -->
                        </v-form>
                    </v-card-text>

                    <!------------ VERIFY datos para encontrar curp  ----------------->
                    <v-card-text v-show="step === 1" class="mx-auto mt-8 width-register" >
                        <v-form   ref="searchCurpRef" v-model="searchCurpFormValid" lazy-validation>
                            <label for="" class="label-form">Nombre(s)</label>
                            <v-text-field
                                    class=""
                                    outlined required v-model="curpSearchRequest.nombres"
                                    placeholder="Nombre(s)"
                                    :rules="[formValidator.name.required]"
                            />
                            <label for="" class="label-form">Apellido paterno</label>
                            <v-text-field
                                    class=""
                                    outlined required v-model="curpSearchRequest.apellido_paterno"
                                    placeholder="Apellido paterno"
                                    :rules="[formValidator.lastname_pat.required]"
                            />
                            <label for="" class="label-form">Apellido materno</label>
                            <v-text-field
                                    class=""
                                    outlined required v-model="curpSearchRequest.apellido_materno"
                                    placeholder="Apellido materno"
                                    :rules="[formValidator.lastname_pat.required]"
                            />

                          
                            <div>
                                    <div>Fecha de Nacimiento</div>
                                <v-menu
                                        ref="menu"
                                        v-model="menu"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                                v-model="birthDate"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                placeholder="Fecha de nacimiento"
                                                v-bind="attrs"
                                                v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                            v-model="birthDate"
                                            :active-picker.sync="activePicker"
                                            :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                                            min="1900-01-01"
                                            :color="pantone"
                                            @change="save"
                                    ></v-date-picker>
                                </v-menu>
                            </div>

                              <div>Sexo</div>
                            <v-radio-group v-model="curpSearchRequest.sexo" row class="mt-0">
                                <template v-slot:label>
                                </template>
                                <v-radio
                                        v-for="item in [{key: 'M', 'label': 'Mujer'}, {key: 'H', label: 'Hombre'}]"
                                        :key="item.key"
                                        :label="item.label"
                                        :value="item.key"
                                ></v-radio>
                            </v-radio-group>

                            <label for="" class="label-form">Estado de nacimiento</label>
                            <v-select
                                    v-model="curpSearchRequest.entidad"
                                    :items="states"
                                    item-text="name"
                                    item-value="id"
                                    outlined
                                    :rules="[formValidator.name.required]"
                            ></v-select>

                            <v-btn block :color="pantoneBlack" x-large class=" white--text v-btn-height" @click="searchCurpRequest">Continuar</v-btn>
                            <v-btn block text :color="pantoneBlack" x-large  class="mb-4" @click="step = 0">Registrarme con CURP</v-btn>
                            <!-- <v-btn block :color="pantoneBlack" large class="mb-4 white--text" @click="cancelRegister()">Cancelar Registro</v-btn> -->
                            <div v-if="!curpSuccess" class="w-100 d-flex">
                                    <label for="" class="mx-auto label-form">¿Ya tienes una cuenta? <a  href="/login"> Inicia sesión</a></label>
                            </div>
                        </v-form>
                    </v-card-text>

                    <!------------ VERIFY CURP  ----------------->
                    <v-card-text v-show="step === 2" class="mx-auto mt-8 width-register" >
                        <v-form ref="phoneValidationRef" v-model="phoneFormValid" lazy-validation>
                            <label for="" class="label-form">Teléfono</label>
                             <div class="d-flex">
                                <v-autocomplete
                                        auto-select-first
                                        max-width="35%"
                                        width="35%"
                                        class="lada"
                                        v-model="lada"
                                        :items="arrayLadas"
                                        item-text="text"
                                        item-value="id"
                                        outlined
                                        :rules="[formValidator.name.required]"
                                >
                                </v-autocomplete>
                                <v-text-field
                                        class=""
                                        outlined required v-model="registerRequest.telefono"
                                        placeholder="Teléfono"
                                        title="El correo que proporciones será el medio por el cual nos estaremos comunicando contigo,
                                            en caso de ser necesario. Por tal razón, asegúrate de que esté correctamente escrito."
                                        :rules="[formValidator.phone.isNumber, formValidator.phone.digits_10]"
                                        type="phone"
                                        maxlength="10"
                                        autofocus
                                />
                             </div>
                            <label for="" class="label-form">Contraseña</label>
                            <v-text-field v-show="!accountStore.googleRegisterRequested && !accountStore.facebookRegisterRequested"
                                    class="password"
                                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="[formValidator.password.required, formValidator.password.min]"
                                    :type="showPassword ? 'text' : 'password'"
                                    title="Asegúrate de que la contraseña sea fácil de recordar, ya que junto con el nombre
                                        de usuario se te solicitará cada vez que desees ingresar al sistema."
                                    placeholder="Ingresa una contraseña que puedas recordar con facilidad."
                                    hint="Ingresa una contraseña que puedas recordar con facilidad"
                                    @click:append="showPassword = !showPassword"
                                    outlined required v-model="registerRequest.password"
                            />
                            <label for="" class="label-form">Confirma contraseña</label>
                            <v-text-field
                                    v-show="!accountStore.googleRegisterRequested && !accountStore.facebookRegisterRequested"
                                    class="password"
                                    :append-icon="showRepeatPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="[formValidator.password.passwordMatch(registerRequest.password_confirm, registerRequest.password)]"
                                    :type="showRepeatPassword ? 'text' : 'password'"
                                    placeholder="Confirma la contraseña"
                                    @click:append="showRepeatPassword = !showRepeatPassword"
                                    outlined required v-model="registerRequest.password_confirm"
                            />
                            <v-btn block  :color="pantoneBlack" x-large class="mb-4 white--text v-btn-height" @click="phoneVerificationRequest()">ENVIAR SMS</v-btn>
                            <!-- <v-btn block :color="pantoneBlack" large class="mb-4 white--text" @click="cancelRegister()">Cancelar Registro</v-btn> -->
                        </v-form>
                    </v-card-text>

                    <!------------ VERIFY CURP  ----------------->
                    <v-card-text v-show="step === 3" class="mx-auto mt-8 width-register">
                        <v-form  class="aux-codigo" ref="confirmSmsCodeRef" v-model="confirmSmsFormValid" lazy-validation>
                            <label for="" class="label-form ">Codigo</label>
                            <v-text-field
                                    outlined required v-model="registerRequest.sms_code"
                                    placeholder=""
                                    :rules="[ rules.counter]"
                                    autofocus
                                    style="width:83%"
                                    dense
                                    counter
                                    number 
                                    id="dexter"
                                    @keyup="changeBlur(registerRequest.sms_code.length)"
                                    maxlength="6"
                                    class="mx-auto"
                            />
                        </v-form>

                        <v-btn block :color="pantoneBlack" ref="continue" x-large class="white--text  v-btn-height" @click="confirmSmsVerificationNumber">Continuar</v-btn>
                        <!-- <v-btn block :color="pantoneBlack" large class="mb-4 white--text" @click="cancelRegister()">Cancelar Registro</v-btn> -->

                        <v-card-subtitle class="text-center">
                            <div>
                            Si eliges continuar, aceptas las
                            <a class="font-weight-bold " @click="showTermsCondDialog(true)">políticas de privacidad</a>: los
                            <a class="font-weight-bold " @click="showTermsCondDialog(false)">términos y condiciones</a>
                            </div>
                        </v-card-subtitle>
                    </v-card-text>

                </v-card>

                <v-dialog
                    v-model="showTermsDialog"
                    scrollable
                    max-width="1200"
                >
                    <v-card>
                        <v-card-title v-if="privacyContent">Aviso de privacidad del sistema</v-card-title>
                        <v-card-title v-else>Términos y condiciones del sistema</v-card-title>
                        <v-card-text>
                            <iframe
                                width="100%"
                                height="700"
                                :src="privacyContent? 'http://pruebas.digitam.tamaulipas.gob.mx/assets/pdf/aviso_privacidad.pdf':
                                    'http://pruebas.digitam.tamaulipas.gob.mx/assets/pdf/terminos_condiciones.pdf'">
                            </iframe>
                        </v-card-text>
                        <v-card-actions class="justify-center">
                            <v-btn color="error" @click="showTermsDialog = false">Cerrar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog
                    v-model="showHelpMessage"
                    scrollable
                    max-width="600"
                >
                    <v-card>
                        <v-card-title class="primary--text">Ayuda</v-card-title>
                        <v-card-subtitle class="pt-4 pb-2">
                            {{helpMessage}}
                        </v-card-subtitle>
                        <v-card-actions class="justify-center">
                            <v-btn color="primary" @click="showHelpMessage = false">Cerrar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-col>
            <img  class="marca-awa"  src="@/assets/img/logo_circular_bco.png" alt="">
        </v-row>
        
    </div>

</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import registerFormValidator from "bestgob-core/form/register.form.validator";
    import {registerRequest} from "bestgob-core/api/models";
    import {createStrongPassword} from "bestgob-core/core/utils";
    import VueRecaptcha from 'vue-recaptcha'
    import {GeneralApi} from "bestgob-core/api";

    import moment from "moment"
    import verifyPhoneRequest from "bestgob-core/api/models/register/verify-phone.request";
    import confirmPhoneRequest from "bestgob-core/api/models/register/confirm-phone.request";


    export default {
        data(){
            return {
                pantone: '#B08C55',
                pantoneBlack: '#15212F',
                recaptchaVerified: false,
                formValidator: registerFormValidator,

                curpFormValid: false,
                searchCurpFormValid: false,
                phoneFormValid: false,
                confirmSmsFormValid: false,

                showPassword: false,
                showRepeatPassword: false,
                registerRequest: registerRequest(),

                curpLoading: false,
                curpError: false,
                curpMessage: '',
                curpSuccess: false,

                termAndCondition: false,
                showTermsDialog: false,
                privacyContent: true,

                captchaError: false,
                showHelpMessage: false,
                helpMessage: "",

                step: 0, //0=curp, 1=search by personal data, 2=phone-pwd, 3=code validation
                FORM: {VERIFY_CURP: 0, SEARCH_CURP: 1, VALIDATE_PHONE: 2, CONFIRM_SMS_CODE: 3},

                currentFormTitle: "Ingresa tu CURP",
                curpSearchRequest: {
                    nombres: '', apellido_paterno: '', apellido_materno:'',
                    fecha_nacimiento: '', sexo: '', entidad:'',
                    client_id: process.env.VUE_APP_OAUTH20_CLIENT_ID
                },

                states: [
                    {id: 'AS', name: 'Aguascalientes'}, {id: 'BC', name: 'Baja California'},
                    {id: 'BS', name: 'Baja California Sur'}, {id: 'CC', name: 'Campeche'},
                    {id: 'CL', name: 'Coahuila'}, {id: 'CM', name: 'Colima'}, {id: 'CS', name: 'Chiapas'},
                    {id: 'CH', name: 'Chihuahua'}, {id: 'DF', name: 'Ciudad de México'}, {id: 'DG', name: 'Durango'},
                    {id: 'GT', name: 'Guanajuato'}, {id: 'GR', name: 'Guerrero'}, {id: 'HG', name: 'Hidalgo'},
                    {id: 'JC', name: 'Jalisco'}, {id: 'MC', name: 'Estado de México'}, {id: 'MN', name: 'Michoacán'},
                    {id: 'MS', name: 'Morelos'}, {id: 'NT', name: 'Nayarit'}, {id: 'NL', name: 'Nuevo León'},
                    {id: 'OC', name: 'Oaxaca'}, {id: 'PL', name: 'Puebla'}, {id: 'QT', name: 'Querétaro'},
                    {id: 'QR', name: 'Quintana Roo'}, {id: 'SP', name: 'San Luis Potosí'}, {id: 'SL', name: 'Sinaloa'},
                    {id: 'SR', name: 'Sonora'}, {id: 'TC', name: 'Tabasco'}, {id: 'TS', name: 'Tamaulipas'},
                    {id: 'TL', name: 'Tlaxcala'}, {id: 'VZ', name: 'Veracruz'}, {id: 'YN', name: 'Yucatán'},
                    {id: 'ZS', name: 'Zacatecas'}, {id: 'NE', name: 'Nacido en el extranjero'}
                ],
                arrayLadas:[
                    {text:'(+52)México	',id:'+52'},
                    {text:'(+93)Afganistán', id: '+93'},
                    {text:'(+355)Albania', id:'+355'},
                    {text:'(+213)Algeria',id:'+213'},
                    {text:'(+49)Alemania', id:'+49'},
                    {text:'(+376)Andorra',id:'+376'},
                    {text:'(+244)Angola',id:'+244'},
                    {text:'(+1 264)Anguila',id:'+1 264'},
                    {text:'(+672)Antártida',id:'+672'},
                    {text:'(+1 268)Antigua y Barbuda',id:'+1 268'},
                    {text:'(+599)Antillas Neerlandesas',id:'+599'},
                    {text:'(+966)Arabia Saudita',id:'+966'},
                    {text:'(+54)Argentina',id:'+54'},
                    {text:'(+374)Armenia',id:'+374'},
                    {text:'(+297)Aruba',id:'+297'},
                    {text:'(+61)Australia',id:'+61'},
                    {text:'(+43)Austria',id:'+43'},
                    {text:'(+994)Azerbayán',id:'+994'},
                    {text:'(+1 242)Bahamas',id:'+1 242'},
                    {text:'(+973)Bahrein',id:'+973'},
                    {text:'(+880)Bangladesh',id:'+880'},
                    {text:'(+1 246)Barbados',id:'+1 246'},
                    {text:'(+32)Bélgica',id:'+32'},
                    {text:'(+501)Belice',id:'+501'},
                    {text:'(+229)Benín',id:'+229'},
                    {text:'(+975)Bhután',id:'+975'},
                    {text:'(+375)Bielorrusia',id:'+375'},
                    {text:'(+95)Birmania',id:'+95'},
                    {text:'(+591)Bolivia',id:'+591'},
                    {text:'(+387)Bosnia y Herzegovina',id:'+387'},
                    {text:'(+267)Botsuana',id:'+267'},
                    {text:'(+55)Brasil',id:'+55'},
                    {text:'(+673)Brunéi',id:'+673'},
                    {text:'(+359)Bulgaria',id:'+359'},
                    {text:'(+226)Burkina Faso',id:'+226'},
                    {text:'(+257)Burundi',id:'+257'},
                    {text:'(+238)Cabo Verde',id:'+238'},
                    {text:'(+855)Camboya',id:'+855'},
                    {text:'(+237)Camerún',id:'+237'},
                    {text:'(+1)Canadá',id:'+1'},
                    {text:'(+235)Chad',id:'+235'},
                    {text:'(+56)Chile	',id:'+56'},
                    {text:'(+86)China',id:'+86'},
                    {text:'(+357)Chipre',id:'+357'},
                    {text:'(+39)Ciudad del Vaticano',id:'+39'},
                    {text:'(+57)Colombia',id:'+57'},
                    {text:'(+269)Comoras',id:'+269'},
                    {text:'(+242)Congo',id:'+242'},
                    {text:'(+243)Congo',id:'+243'},
                    {text:'(+850)Corea del Norte',id:'+850'},
                    {text:'(+82)Corea del Sur	',id:'+82'},
                    {text:'(+225)Costa de Marfil	',id:'+225'},
                    {text:'(+506)Costa Rica	',id:'+506'},
                    {text:'(+385)Croacia	',id:'+385'},
                    {text:'(+53)Cuba	',id:'+53'},
                    {text:'(+45)Dinamarca	',id:'+45'},
                    {text:'(+1 767)Dominica	',id:'+1 767'},
                    {text:'(+593)Ecuador	',id:'+593'},
                    {text:'(+20)Egipto	',id:'+20'},
                    {text:'(+503)El Salvador	',id:'+503'},
                    {text:'(+971)Emiratos Árabes Unidos	',id:'+971'},
                    {text:'(+291)Eritrea	',id:'+291'},
                    {text:'(+421)Eslovaquia	',id:'+421'},
                    {text:'(+386)Eslovenia	',id:'+386'},
                    {text:'(+34)España	',id:'+34'},
                    {text:'(+1)Estados Unidos de América	',id:'+1 '},
                    {text:'(+372)Estonia	',id:'+372'},
                    {text:'(+251)Etiopía	',id:'+251'},
                    {text:'(+63)Filipinas	',id:'+63'},
                    {text:'(+358)Finlandia	',id:'+358'},
                    {text:'(+679)Fiyi	',id:'+679'},
                    {text:'(+33)Francia	',id:'+33'},
                    {text:'(+241)Gabón	',id:'+241'},
                    {text:'(+220)Gambia	',id:'+220'},
                    {text:'(+995)Georgia	',id:'+995'},
                    {text:'(+233)Ghana	',id:'+233'},
                    {text:'(+350)Gibraltar	',id:'+350'},
                    {text:'(+1 473)Granada	',id:'+1 473'},
                    {text:'(+30)Grecia	',id:'+30'},
                    {text:'(+299)Groenlandia	',id:'+299'},
                    {text:'(+1 671)Guam	',id:'+1 671'},
                    {text:'(+502)Guatemala	',id:'+502'},
                    {text:'(+224)Guinea	',id:'+224'},
                    {text:'(+240)Guinea Ecuatorial	',id:'+240'},
                    {text:'(+245)Guinea-Bissau	',id:'+245'},
                    {text:'(+592)Guyana	',id:'+592'},
                    {text:'(+509)Haití	',id:'+509'},
                    {text:'(+504)Honduras	',id:'+504'},
                    {text:'(+852)Hong kong	',id:'+852'},
                    {text:'(+36)Hungría	',id:'+36'},
                    {text:'(+91)India	',id:'+91'},
                    {text:'(+62)Indonesia	',id:'+62'},
                    {text:'(+964)Irak	',id:'+964'},
                    {text:'(+98)Irán	',id:'+98'},
                    {text:'(+353)Irlanda	',id:'+353'},
                    {text:'(+44)Isla de Man	',id:'+44'},
                    {text:'(+61)Isla de Navidad	',id:'+61'},
                    {text:'(+354)Islandia	',id:'+354'},
                    {text:'(+1 441)Islas Bermudas	',id:'+1 441'},
                    {text:'(+1 345)Islas Caimán	',id:'+1 345'},
                    {text:'(+61)Islas Cocos	',id:'+61'},
                    {text:'(+682)Islas Cook	',id:'+682'},
                    {text:'(+298)Islas Feroe	',id:'+298'},
                    {text:'(+960)Islas Maldivas	',id:'+960'},
                    {text:'(+500)Islas Malvinas	',id:'+500'},
                    {text:'(+1 670)Islas Marianas del Norte	',id:'+1 670'},
                    {text:'(+692)Islas Marshall	',id:'+692'},
                    {text:'(+870)Islas Pitcairn	',id:'+870'},
                    {text:'(+677)Islas Salomón	',id:'+677'},
                    {text:'(+1 649)Islas Turcas y Caicos	',id:'+1 649'},
                    {text:'(+1 284)Islas Vírgenes Británicas	',id:'+1 284'},
                    {text:'(+1 340)Islas Vírgenes de los Estados Unidos	',id:'+1 340'},
                    // {text:'(+972)Israel	',id:'+972'},
                    {text:'(+39)Italia	',id:'+39'},
                    {text:'(+1 876)Jamaica	',id:'+1 876'},
                    {text:'(+81)Japón	',id:'+81'},
                    {text:'(+962)Jordania	',id:'+962'},
                    {text:'(+7)Kazajistán	',id:'+7'},
                    {text:'(+254)Kenia	',id:'+254'},
                    {text:'(+996)Kirgizstán	',id:'+996'},
                    {text:'(+686)Kiribati	',id:'+686'},
                    {text:'(+965)Kuwait	',id:'+965'},
                    {text:'(+856)Laos	',id:'+856'},
                    {text:'(+266)Lesoto	',id:'+266'},
                    {text:'(+371)Letonia	',id:'+371'},
                    {text:'(+961)Líbano	',id:'+961'},
                    {text:'(+231)Liberia	',id:'+231'},
                    {text:'(+218)Libia	',id:'+218'},
                    {text:'(+423)Liechtenstein	',id:'+423'},
                    {text:'(+370)Lituania	',id:'+370'},
                    {text:'(+352)Luxemburgo	',id:'+352'},
                    {text:'(+853)Macao	',id:'+853'},
                    {text:'(+389)Macedônia	',id:'+389'},
                    {text:'(+261)Madagascar	',id:'+261'},
                    {text:'(+60)Malasia	',id:'+60'},
                    {text:'(+265)Malawi	',id:'+265'},
                    {text:'(+223)Mali	',id:'+223'},
                    {text:'(+356)Malta	',id:'+356'},
                    {text:'(+212)Marruecos	',id:'+212'},
                    {text:'(+230)Mauricio	',id:'+230'},
                    {text:'(+222)Mauritania	',id:'+222'},
                    {text:'(+262)Mayotte	',id:'+262'},
                    {text:'(+52)México	',id:'+52'},
                    {text:'(+691)Micronesia	',id:'+691'},
                    {text:'(+373)Moldavia	',id:'+373'},
                    {text:'(+377)Mónaco	',id:'+377'},
                    {text:'(+976)Mongolia	',id:'+976'},
                    {text:'(+382)Montenegro	',id:'+382'},
                    {text:'(+1 664)Montserrat	',id:'+1 664'},
                    {text:'(+258)Mozambique	',id:'+258'},
                    {text:'(+264)Namibia	',id:'+264'},
                    {text:'(+674)Nauru	',id:'+674'},
                    {text:'(+977)Nepal	',id:'+977'},
                    {text:'(+505)Nicaragua	',id:'+505'},
                    {text:'(+227)Niger	',id:'+227'},
                    {text:'(+234)Nigeria	',id:'+234'},
                    {text:'(+683)Niue	',id:'+683'},
                    {text:'(+47)Noruega	',id:'+47'},
                    {text:'(+687)Nueva Caledonia	',id:'+687'},
                    {text:'(+64)Nueva Zelanda	',id:'+64'},
                    {text:'(+968)Omán	',id:'+968'},
                    {text:'(+31)Países Bajos	',id:'+31'},
                    {text:'(+92)Pakistán	',id:'+92'},
                    {text:'(+680)Palau	',id:'+680'},
                    {text:'(+507)Panamá	',id:'+507'},
                    {text:'(+675)Papúa Nueva Guinea	',id:'+675'},
                    {text:'(+595)Paraguay	',id:'+595'},
                    {text:'(+51)Perú	',id:'+51'},
                    {text:'(+689)Polinesia Francesa	',id:'+689'},
                    {text:'(+48)Polonia	',id:'+48'},
                    {text:'(+351)Portugal	',id:'+351'},
                    {text:'(+1)Puerto Rico	',id:'+1  '},
                    {text:'(+974)Qatar	',id:'+974'},
                    {text:'(+44)Reino Unido	',id:'+44'},
                    {text:'(+236)República Centroafricana	',id:'+236'},
                    {text:'(+420)República Checa	',id:'+420'},
                    {text:'(+1 809)República Dominicana	',id:'+1 809'},
                    {text:'(+250)Ruanda	',id:'+250'},
                    {text:'(+40)Rumanía	',id:'+40'},
                    {text:'(+7)Rusia	',id:'+7'},
                    {text:'(+685)Samoa	',id:'+685'},
                    {text:'(+1 684)Samoa Americana	',id:'+1 684'},
                    {text:'(+590)San Bartolomé	',id:'+590'},
                    {text:'(+1 869)San Cristóbal y Nieves	',id:'+1 869'},
                    {text:'(+378)San Marino	',id:'+378'},
                    {text:'(+1 599)San Martín (Francia)	',id:'1 599'},
                    {text:'(+508)San Pedro y Miquelón	',id:'+508'},
                    {text:'(+1 784)San Vicente y las Granadinas	',id:'+1 784'},
                    {text:'(+290)Santa Elena	',id:'+290'},
                    {text:'(+1 758)Santa Lucía	',id:'+1 758'},
                    {text:'(+239)Santo Tomé y Príncipe	',id:'+239'},
                    {text:'(+221)Senegal	',id:'+221'},
                    {text:'(+381)Serbia	',id:'+381'},
                    {text:'(+248)Seychelles	',id:'+248'},
                    {text:'(+232)Sierra Leona	',id:'+232'},
                    {text:'(+65)Singapur	',id:'+65'},
                    {text:'(+963)Siria	',id:'+963'},
                    {text:'(+252)Somalia	',id:'+252'},
                    {text:'(+94)Sri lanka	',id:'+94'},
                    {text:'(+27)Sudáfrica	',id:'+27'},
                    {text:'(+249)Sudán	',id:'+249'},
                    {text:'(+46)Suecia	',id:'+46'},
                    {text:'(+41)Suiza	',id:'+41'},
                    {text:'(+597)Surinám	',id:'+597'},
                    {text:'(+268)Swazilandia	',id:'+268'},
                    {text:'(+992)Tadjikistán	',id:'+992'},
                    {text:'(+66)Tailandia	',id:'+66'},
                    {text:'(+886)Taiwán	',id:'+886'},
                    {text:'(+255)Tanzania	',id:'+255'},
                    {text:'(+670)Timor Oriental	',id:'+670'},
                    {text:'(+228)Togo	',id:'+228'},
                    {text:'(+690)Tokelau	',id:'+690'},
                    {text:'(+676)Tonga	',id:'+676'},
                    {text:'(+1 868)Trinidad y Tobago	',id:'+1 868'},
                    {text:'(+216)Tunez	',id:'+216'},
                    {text:'(+993)Turkmenistán	',id:'+993'},
                    {text:'(+90)Turquía	',id:'+90'},
                    {text:'(+688)Tuvalu	',id:'+688'},
                    {text:'(+380)Ucrania	',id:'+380'},
                    {text:'(+256)Uganda	',id:'+256'},
                    {text:'(+598)Uruguay	',id:'+598'},
                    {text:'(+998)Uzbekistán	',id:'+998'},
                    {text:'(+678)Vanuatu	',id:'+678'},
                    {text:'(+58)Venezuela	',id:'+58'},
                    {text:'(+84)Vietnam	',id:'+84'},
                    {text:'(+967)Yemen	',id:'+967'},
                    {text:'(+253)Yibuti	',id:'+253'},
                    {text:'(+260)Zambia	',id:'+260'},
                    {text:'(+263)Zimbabue	',id:'+263'},

                ],                  activePicker: null,
                lada: null,
                birthDate: null,
                menu: false,
                rules: {
                    counter: value => value?.length <= 6|| 'Max 6 characters',
                }
            }
        },
        components: {VueRecaptcha},
        created() {
            this.$gtag.event('registro', { method: 'Google' }) // Google Analytics
            this.lada = this.arrayLadas[0]
        },
        computed: {
            ...mapState({accountStore: state => state.account}),
        },

        watch:{
            'registerRequest.curp'(data){
                this.curpInputChange(data)
            },
            
            recaptchaVerified(){
                this.curpInputChange(this.registerRequest.curp)
            },
            menu (val) {
                val && setTimeout(() => (this.activePicker = 'YEAR'))
            },

            birthDate(value) {
                this.curpSearchRequest.fecha_nacimiento = moment(value).format("DD/MM/YYYY")
            },

            step(){
                this.updateFormTitle()
            },

            '$store.state.account.verificationPhoneData'(){
                if (this.accountStore.verificationPhoneData != null){
                    this.phoneVerificationResponseSuccess()
                }
            },

            '$store.state.account.confirmPhoneSuccess'(){
                if (this.accountStore.confirmPhoneSuccess){
                    this.accountStore.confirmPhoneSuccess = false
                    this.confirmSmsVerificationResponseSuccess()
                }
            },

            '$store.state.account.searchCurpResult'(){
                if (this.accountStore.searchCurpResult !=null ){
                    this.searchCurpByNameSuccess()
                }
            }
        },

    

        mounted() {
            if (this.accountStore.loggedIn){
                this.$router.push({name: 'home'})
            }

            if (this.accountStore.googleRegisterRequested){
                this.initFillForm(this.accountStore.googleUserData)
            }

            if (this.accountStore.facebookRegisterRequested){
                this.initFillForm(this.accountStore.facebookUserData)
            }

            window.onpopstate = () => {
                this.cancelRegisterWitGoogleOrFacebook()
            }

            this.updateFormTitle()
        },

        methods: {
            ...mapActions('account', [
                'registerUser', 'cancelRegisterWitGoogleOrFacebook', 'validateEmailAndUsername',
                'verifyPhone', 'confirmPhone', 'searchCurpByName'
            ]),

            changeBlur(size){
                console.log(size);
                if(size == 6 ){
                    console.log('====');
                    this.$refs.continue.$el.focus();
                }
            },
            /**
             * Se actualiza el titulo del Formulario cada que se avanza
             */
            updateFormTitle(){
                switch(this.step){
                    case this.FORM.VERIFY_CURP:
                        this.currentFormTitle = "Ingresa tu curp"
                        break;
                    case this.FORM.SEARCH_CURP:
                        this.currentFormTitle = "Ingresa los siguientes datos"
                        break;
                    case this.FORM.VALIDATE_PHONE:
                        this.currentFormTitle = "Ingresa los siguientes datos"
                        break;
                    case this.FORM.CONFIRM_SMS_CODE:
                        this.currentFormTitle = "Ingresa el código que te enviamos"
                        break;
                }
            },

            searchCurpRequest(){
                this.$refs.searchCurpRef.validate()
                if (this.searchCurpFormValid){
                    this.searchCurpByName(this.curpSearchRequest)
                }
            },

            searchCurpByNameSuccess(){
                let curpInfo = this.accountStore.searchCurpResult

                this.registerRequest.nombres = curpInfo.nombres
                this.registerRequest.apellido_paterno = curpInfo.apePat
                this.registerRequest.apellido_materno = curpInfo.apeMat
                this.registerRequest.curp = curpInfo.curp

                this.step = 2
            },

            //Form of Step 0
            postCurFormValidation(){
                this.$refs.curpValidationRef.validate();
                if (this.curpFormValid){
                    this.step = 2
                }
            },

            //Form of Step 2
            phoneVerificationRequest(){
                this.$refs.phoneValidationRef.validate();
                console.log(this.phoneFormValid);
                if (this.phoneFormValid){
                    let request = verifyPhoneRequest()
                    request.telefono = `${this.lada.id ?  this.lada.id.replace(/\s/g, ''): this.lada.replace(/\s/g, '')}${this.registerRequest.telefono}`
                    request.password = this.registerRequest.password
                    request.password_confirm = this.registerRequest.password_confirm

                    this.verifyPhone(request)
                }
            },

            phoneVerificationResponseSuccess(){
                this.registerRequest.sid = this.accountStore.verificationPhoneData.sid

                this.step = 3
            },

            //Form of Step 3
            confirmSmsVerificationNumber(){
                this.$refs.confirmSmsCodeRef.validate

                if (this.confirmSmsFormValid){
                    let request = confirmPhoneRequest()
                    request.telefono = this.registerRequest.telefono
                    request.sid = this.registerRequest.sid
                    request.code = this.registerRequest.sms_code

                    this.confirmPhone(request)
                }
            },

            confirmSmsVerificationResponseSuccess(){
                this.registerRequest['url_redirect'] = window.location.origin
                this.registerRequest.telefono = `${this.lada.id ?  this.lada.id.replace(/\s/g, ''): this.lada.replace(/\s/g, '')}${this.registerRequest.telefono}`
                this.registerUser(this.registerRequest)
            },



            help(message){
                this.helpMessage = message
                this.showHelpMessage = true
            },

            /**
             * Prellenar formulario cuando el usuario se registra por google/facebook
             *
             * @param userData
             */
            initFillForm(userData){
                this.registerRequest.usuario = userData.id
                this.registerRequest.email = userData.email
                this.registerRequest.avatar = userData.icon
                this.registerRequest.password = createStrongPassword(
                    userData.id,
                    this.accountStore.facebookRegisterRequested ? userData.id : userData.email
                )
                this.registerRequest.password_confirm = createStrongPassword(
                    userData.id,
                    this.accountStore.facebookRegisterRequested ? userData.id : userData.email
                )
                this.validateUniqueCredentials()
            },

            validateUniqueCredentials(){
                let request = {
                    username: this.registerRequest.usuario,
                    email: this.registerRequest.email,
                    client_id: process.env.VUE_APP_OAUTH20_CLIENT_ID
                }

                this.validateEmailAndUsername(request)
                this.showNextForm = true
            },

            cancelRegister(){
                this.registerRequest = registerRequest()

                //Try clear google or facebook register request
                this.cancelRegisterWithGoogleOrFacebook()
            },

            cancelRegisterWithGoogleOrFacebook(){
                this.cancelRegisterWitGoogleOrFacebook()
            },

            getCaptchaSiteKey(){
                return process.env.VUE_APP_RECAPTCHA_SITE_KEY
            },

            verifyReCaptcha(){
                this.recaptchaVerified = true
            },

            expiredRecaptcha(){
                this.recaptchaVerified = false
            },

            async curpInputChange(curp){
                if (curp.length == 18){
                    this.curpError = false
                    this.curpMessage = ''
                    if(this.recaptchaVerified){
                        try {
                            this.curpLoading = true
                            let curpResult = await GeneralApi.verifyCurp(curp)
                            let years = moment().diff(moment(curpResult.fechaNac, 'DD/MM/YYYY'), 'years')

                            if (years >= 18){
                                this.registerRequest.nombres = curpResult.nombres
                                this.registerRequest.apellido_paterno = curpResult.apePat
                                this.registerRequest.apellido_materno = curpResult.apeMat
                                this.curpSuccess = true
                            }else{
                                this.curpError = true
                                this.curpMessage = 'La CURP es de un menor de edad, no es admitido'
                            }
                        }catch (error){
                            this.curpError = true
                            this.curpMessage = error.message //'La CURP no fue encontrada'

                            this.registerRequest.nombres = ''
                            this.registerRequest.apellido_paterno = ''
                            this.registerRequest.apellido_materno = ''
                        }
                    }

                    this.curpLoading = false


                }
            },

            showTermsCondDialog(privacyContent = true){
                this.showTermsDialog = true
                this.privacyContent = privacyContent
            },

            backRegister(){
                this.accountStore.emailOrUsernameValid = false
            },

            save (date) {
                this.$refs.menu.save(date)
            },
        }
    };
</script>

<style>
    .lada{
        width: 28% !important;
        max-width: 25% !important;
        margin-right: 1rem !important;
    }
    .lada input{
        text-indent: 5px;
    }

    .v-application.fondo_login .v-text-field__slot  input{
        box-sizing: content-box;
    }

    input, textarea, select { 
        font-family:'PoppinsRegular';
    }

    .no-justify-center-mobile{
        justify-content: center;
    }

    .fondo-register-mobile{
        display: none;
    }
    .marca-awa{
        position: absolute;
        right: 5%;
        bottom: 2rem;
        width: 150px;
        height: 150px;
    }
    .img-logo-nl{
        width:200px;
        position: absolute;
         top:5%;
         margin-left: auto;
         margin-right: auto;
         left: 0;
         right: 0;
    }
    .width-register{
        width:75%
    }
    .v-input__prepend-outer{
        display: none !important;
    }
    .v-application.fondo_login #rc-anchor-container{
        background: rgb(250 250 250 / 18%) !important;
        border: 0px !important;
    }
     .v-application.fondo_login fieldset{
        /* border-bottom: 0px !important */
    }
    .v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot{
        /* min-height: unset !important; */
        /* height: 3rem; */
    }
    .v-input__control{
        border-radius: 5px !important;
    }
    .v-text-field--full-width .v-input__prepend-outer, .v-text-field--full-width .v-input__prepend-inner, .v-text-field--full-width .v-input__append-inner, .v-text-field--full-width .v-input__append-outer, .v-text-field--enclosed .v-input__prepend-outer, .v-text-field--enclosed .v-input__prepend-inner, .v-text-field--enclosed .v-input__append-inner, .v-text-field--enclosed .v-input__append-outer{
        margin-top: 0 !important;
        border-bottom: 0px !important
    }

    .v-text-field--focused{
        transition: unset !important;   
    }
    .v-input input {
        max-height: 1rem ;
    }
    .v-input--radio-group__input{
        margin-left: -1rem;
    }
    /* .v-input__slot{
        align-items: center;
        color: inherit;
        display: flex;
        min-height: inherit;
        width: 100%;
        padding: .9rem  1rem !important;
        font-size: .7rem;
        line-height: 1.5;
        border-radius: 10px;
        display: flex;
        color: #ff8400 !important;
        background-color: #fff !important;
        background-clip: padding-box;
        border: 1px  solid #ff8400;
        border-radius: 0.25rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }     */
    .form-ejemplo{
        padding: .9rem  1rem;
        margin: auto;
        font-size: 1.25rem;
        line-height: 1.5;
        border-radius: 0.3rem;
        display: block;
        width: 75%;
        color: #ff8400;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px  solid #ff8400;
        border-radius: 0.25rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }
    .form-ejemplo:focus-visible{
        outline: -webkit-focus-ring-color auto 0px !important;
    }
    .theme--light.v-divider {
        border-color: #ff840059;
        height: 3px !important;
        border-width: thin 0px  1px  0px;
    }
    .label-form{
        color: black !important;
        font-family: 'PoppinsRegular';
        font-weight: 500;
    }
    .v-application .primary--text{
        color: #B08C55 !important;
        caret-color: #B08C55 !important;
    }
    .v-text-field__slot input{
       text-transform: uppercase
    }
    .v-input--radio-group{
        border: unset !important
    }
    .v-input--selection-controls .v-input__slot{
        border: unset !important
    }
    .v-text-field{
        margin-top: 0px !important
    }


    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
    

    .aux-codigo , .v-input >v-input__control {
        border: none !important;
    }

    #dexter{
        border: none;
        width: 10.5ch;
        background: 
            repeating-linear-gradient(90deg, 
                #ff8400 0, 
                #ff8400 1ch, 
                transparent 0, 
                transparent 3ch) 
            0 100%/100% 2px no-repeat;
        color: dimgrey;
        font: 5ch consolas, monospace;
        letter-spacing: 2ch;
    }

    .aux-codigo   .v-input .v-input__control  .v-input__slot{
        border: unset;
        min-height: 2rem !important;
    }
    .aux-codigo   .v-input .v-input__control  .v-input__slot .v-text-field__slot input{
       height: 2rem  !important;
       max-height: 2rem !important;
    }

    @media only screen and (max-width: 330px ) {
        #dexter{
            border: none;
            width: 10.5ch;
            background: 
                repeating-linear-gradient(90deg, 
                    #ff8400 0, 
                    #ff8400 .7ch, 
                    transparent 0, 
                    transparent 1.9ch) 
                0 100%/100% 2px no-repeat;
            color: dimgrey;
            font: 5ch consolas, monospace;
            letter-spacing: .75ch;
        }
        
    }


    @media only screen and (max-width: 959px  ) and (min-width: 771px) {
        .aux-codigo{
            max-width: 27rem;
            margin-left: auto;
            margin-right: auto;
        }
         #dexter{
        border: none;
        width: 10.5ch;
        background: 
            repeating-linear-gradient(90deg, 
                #ff8400 0, 
                #ff8400 1ch, 
                transparent 0, 
                transparent 3ch) 
            0 100%/100% 2px no-repeat;
        color: dimgrey;
        font: 5ch consolas, monospace;
        letter-spacing: 2ch;
    }
    }

    @media only screen and (max-width: 770px) {
        .bttn-go-back{
            position:absolute;
            z-index:200;
            top:20px
        }

        .aux-codigo{
            max-width: 17rem;
            margin-left: auto;
            margin-right: auto;
        }

        .a-10{
            height: 10%;
        }
        .no-justify-center-mobile{
            justify-content: start;
            padding: 1.8rem 0 
        }
        .mobile-column{
            flex-direction: column;
        }
        .width-register{
            width: 100%
        }
        .img-logo-nl{
            width:150px;
            position: relative;
            margin: 10px 0px;
            top:5%;
            margin-left: auto;
            margin-right: auto;
            left: 0;
            right: 0;
            z-index: 1;
        }
        .marca-awa{
            position: absolute;
            right: 5%;
            bottom: 2rem;
            width: 100px;
            height: 100px;
        }
        .v-btn--block{
            max-width: 100% !important;
        }
        .fondo-register-mobile{
            position: absolute;
            display: initial;
            height: 51%;
            width: 90%;
            background-color: #e2d6c2;
            z-index: 0;
            top: 0;
            left: 5%;
            right: 5%;
        }
        .v-application .pa-6{
            padding: 10px !important;
        }
        #dexter{
            border: none;
            width: 10.5ch;
            background: 
                repeating-linear-gradient(90deg, 
                    #ff8400 0, 
                    #ff8400 .7ch, 
                    transparent 0, 
                    transparent 1.9ch) 
                0 100%/100% 2px no-repeat;
            color: dimgrey;
            font: 5ch consolas, monospace;
            letter-spacing: .75ch;
        }
    }   
    @media only screen and (min-width: 959px) {
        .aux-codigo{
            max-width: 27rem;
            min-width: 27rem;
            margin-left: auto;
            margin-right: auto;
        }
    }
</style>
